import { FC } from 'react';
import { Button } from '@/components/ui/button';
import { AnyDevice } from '@/types/device';

export type SelectedDevicesActionBarProps = {
  selectedDevices: AnyDevice[];
  unlinkDisabled: boolean;
  linkDeviceButtonText?: string;
  unlinkDeviceButtonText?: string;
  onLinkDevicesClick: () => void;
  onUnlinkDevicesClick: () => void;
};

export const SelectedDevicesActionBar: FC<SelectedDevicesActionBarProps> = ({
  unlinkDisabled,
  selectedDevices = [],
  linkDeviceButtonText = 'Link device',
  unlinkDeviceButtonText = 'Unlink device',
  onLinkDevicesClick,
  onUnlinkDevicesClick,
}) => {
  if (selectedDevices.length === 0) {
    return null;
  }

  return (
    <div className="mb-5 flex flex-row items-center justify-between gap-4 rounded-lg bg-gray-800 p-4">
      {/* TODO: add selected checkbox, not a priority right now */}
      <div className="w-20 text-sm font-semibold text-white">{`${selectedDevices.length} selected`}</div>
      <div className="flex gap-2">
        <Button onClick={onLinkDevicesClick} variant="secondary">
          {linkDeviceButtonText}
        </Button>
        <Button
          disabled={unlinkDisabled}
          onClick={onUnlinkDevicesClick}
          variant="secondary"
        >
          {unlinkDeviceButtonText}
        </Button>
      </div>
    </div>
  );
};
